
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Das erste Restaurant der Bonsoir GmbH war das mittlerweile geschlossene
  Kung-Fu Burger an der Speichergasse. Darauf folgten 2017 die Restaurants der
  Stadtberner Sportanlagen Wyler, Weyermannshaus und Ka-We-De. Die
  Verantwortlichen kommen aber eigentlich aus dem Nachtleben, führten den Club
  Wasserwerk im Mattequartier und bis 2017 das Bonsoir in der Aarbergergasse.
  Rolf Bähler, Christoph Haller, Didier Steiner, Marco Belz, Arci Friede und
  Dave Marshal halten mit drei Firmen (Yuhuzimi, Prop, Rebelmind Syndicate) je
  ein Drittel Anteile an der Bonsoir GmbH. Der Bonsoir GmbH ihrerseits gehört
  die Badi Beizli GmbH, und sie hat Anteile am City Pub in der Aarbergergasse.
    </p>
    <p>
  Das Lokal von Kung-Fu Burger übergaben sie wegen schlechter Auslastung im
  Sommer an eine Zwischennutzung, und ab Februar übernimmt dort ein Zürcher
  Gastrounternehmen. Bei den Badibeizen verpassten sie dem üblichen Badimenü wie
  Schnipo einen modernen Touch. So handelten sie sich im Sommer 2017
  «Hotdog-Gate» ein, bei dem der Preis des Biowürstchens von ganz Bern
  diskutiert wurde. In der Zwischenzeit ist eine günstigere Variante für
  Familien auf der Karte. Ihre Beizli füllen sie in der Zwischensaison mit
  Pop-ups, derzeit kochen im Wylerbad Gastköche. Das Restaurant im
  Weyermannshaus geben sie per Anfang Sommer ab, dort übernehmen die
  City-Pub-Barkeeper Christian Stoop und Adrian Franz mit der jetzigen
  Gastgeberin Eva-Larissa Eidam. «Das Weyerli hat immer eine andere Klientel
  angezogen als das Ka-We-De oder das Wylerbad», sagt Arci Friede. Die sechs
  Beteiligten des Unternehmens driften seit längerem in unterschiedliche
  Richtungen. Dieses Jahr werde man sich neu aufstellen, sagt Friede
  stellvertretend für alle. Gastronomisch operativ sei derzeit nur noch Marco
  Belz. Über ihren Umsatz gibt es keine Angaben.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;